<template>
    <div class="mobile-menu-text">
        <span :href="url">
            <div style="display: flex; align-items: center;">
                <img width="48" heigh="48" v-if="icon" :src="icon" /> 
                <span class="text">{{name}}</span>    
            </div>
        </span>
    </div>
</template>

<script>

export default {
    props: ["name", "icon", "url"],
    components: {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
    .mobile-menu-text {
        img {
            border-radius: 100px;
            border: solid 2px white;
            margin-right: 8px;
        }
        .text {
            font-weight: 600;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 180px;
        }
    }
</style>

